import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Check, X, AlertCircle } from 'lucide-react';
export function ProblemSection() {
  return <>
      {/* Opening Lead */}
      <section className="py-20 px-4 bg-white" data-id="element-165">
        <div className="max-w-2xl mx-auto text-center md:text-left" data-id="element-166">
          <FadeIn data-id="element-167">
            <h2 className="text-3xl md:text-4xl font-serif text-[#3D3D3D] mb-8 text-center" data-id="element-168">
              Hay un tipo de ansiedad que nadie ve.
            </h2>
          </FadeIn>

          <div className="space-y-6 text-lg text-[#5A6B5A] leading-relaxed font-light" data-id="element-169">
            <FadeIn delay={0.1} data-id="element-170">
              <p data-id="element-171">
                La que no te tumba. La que te deja{' '}
                <strong className="font-medium text-[#3D3D3D]" data-id="element-172">
                  funcionar
                </strong>
                .
              </p>
            </FadeIn>
            <FadeIn delay={0.2} data-id="element-173">
              <p data-id="element-174">Cumples. Resuelves. Sostienes.</p>
            </FadeIn>
            <FadeIn delay={0.3} data-id="element-175">
              <p data-id="element-176">
                Y aun así… por dentro estás en alerta: el cuerpo tenso, la mente
                corriendo, el humor corto.
              </p>
            </FadeIn>
            <FadeIn delay={0.4} data-id="element-177">
              <p data-id="element-178">Lo peor no es el cansancio.</p>
            </FadeIn>
            <FadeIn delay={0.5} data-id="element-179">
              <p className="text-xl md:text-2xl font-serif text-[#C4836A] italic" data-id="element-180">
                Lo peor es esa sensación de que ya ni siquiera sabes cómo se
                siente estar en paz sin tener que ganártela.
              </p>
            </FadeIn>
          </div>
        </div>
      </section>

      {/* Pain Points - Esto es para ti si... */}
      <section className="py-20 px-4 bg-[#FAF8F5]" data-id="element-181">
        <div className="max-w-4xl mx-auto" data-id="element-182">
          <FadeIn data-id="element-183">
            <h3 className="text-2xl md:text-3xl font-serif text-[#3D3D3D] mb-12 text-center" data-id="element-184">
              Esto es para ti si...
            </h3>
          </FadeIn>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-185">
            {["Te despiertas y tu mente ya está 'en lista de pendientes'.", 'Estás irritable sin querer, y luego te cae la culpa.', 'Intentas organizarte y terminas más tensa.', "Te dices 'cuando tenga tiempo' para cuidarte… y ese tiempo no llega.", 'Sientes que si aflojas tantito, todo se desordena.'].map((item, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-186">
                <div className="flex items-start p-6 bg-white rounded-xl shadow-sm border border-[#E5E0D8]" data-id="element-187">
                  <div className="flex-shrink-0 mr-4" data-id="element-188">
                    <div className="w-6 h-6 rounded-full bg-[#C4836A]/10 flex items-center justify-center text-[#C4836A]" data-id="element-189">
                      <Check size={14} strokeWidth={3} data-id="element-190" />
                    </div>
                  </div>
                  <p className="text-[#5A6B5A]" data-id="element-191">{item}</p>
                </div>
              </FadeIn>)}
          </div>
        </div>
      </section>

      {/* Reframe - Lo que nadie te dijo */}
      <section className="py-20 px-4 bg-[#8B9E8B] text-white" data-id="element-192">
        <div className="max-w-3xl mx-auto text-center" data-id="element-193">
          <FadeIn data-id="element-194">
            <h3 className="text-2xl md:text-3xl font-serif mb-8" data-id="element-195">
              Lo que nadie te dijo
            </h3>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-196">
            <div className="space-y-4 text-lg md:text-xl font-light leading-relaxed opacity-90" data-id="element-197">
              <p data-id="element-198">No es que seas dramática.</p>
              <p data-id="element-199">No es que "te falte meditar".</p>
              <p data-id="element-200">No es que "no sepas agradecer".</p>
              <p className="pt-4 font-medium text-2xl" data-id="element-201">
                Es que estás intentando vivir una vida llena con un sistema
                nervioso trabajando horas extra…
              </p>
              <p data-id="element-202">
                y con herramientas que piden tiempo y energía que ya no tienes.
              </p>
            </div>
          </FadeIn>
        </div>
      </section>

      {/* Failed Solutions */}
      <section className="py-20 px-4 bg-white" data-id="element-203">
        <div className="max-w-4xl mx-auto" data-id="element-204">
          <FadeIn data-id="element-205">
            <h3 className="text-2xl md:text-3xl font-serif text-[#3D3D3D] mb-4 text-center" data-id="element-206">
              Por qué lo que has probado te falló
            </h3>
            <p className="text-center text-[#5A6B5A] mb-12" data-id="element-207">
              (aunque "sirva" para otros)
            </p>
          </FadeIn>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-8" data-id="element-208">
            {[{
            title: 'Meditaciones largas',
            desc: 'Te frustran porque tu mente no está entrenada para estar quieta cuando está activada.'
          }, {
            title: 'Journaling perfecto',
            desc: 'Se vuelve tarea, y se abandona.'
          }, {
            title: "Rutinas 'de Pinterest'",
            desc: 'Funcionan en vacaciones, no en martes.'
          }, {
            title: 'Listas y más listas',
            desc: 'Te dan ilusión de control, pero te dejan en deuda mental.'
          }].map((item, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-209">
                <div className="h-full p-8 bg-[#FAF8F5] rounded-2xl border-l-4 border-[#C4836A]" data-id="element-210">
                  <h4 className="text-lg font-bold text-[#3D3D3D] mb-3" data-id="element-211">
                    {item.title}
                  </h4>
                  <p className="text-[#5A6B5A]" data-id="element-212">{item.desc}</p>
                </div>
              </FadeIn>)}
          </div>

          <FadeIn delay={0.4} className="mt-12 text-center" data-id="element-213">
            <p className="text-lg text-[#3D3D3D] font-medium" data-id="element-214">
              Si te ha pasado, no es porque no puedas. <br data-id="element-215" />
              <span className="text-[#C4836A]" data-id="element-216">
                Es porque estabas intentando arreglar una fuga con una manguera
                rota.
              </span>
            </p>
          </FadeIn>
        </div>
      </section>
    </>;
}